import { Get, Post } from "../../../infra/data/api";
import { ICampanhaPedidoResgateService } from "../../../interfaces/_carteira/campanhaPedidoResgate/ICampanhaPedidoResgateService";
import { CampanhaPedidoResgateResponse } from "../../../types/_carteira/campanhaPedidoResgate/campanhaPedidoResgateResponse";
import DomainConstants from "../../../infra/data/domainConstants";
import { PagedListRequest, PagedSortType } from "../../../types/global/pagedListRequest";
import { PagedListResponse } from "../../../types/global/pagedListResponse";

export class CampanhaPedidoResgateService implements ICampanhaPedidoResgateService {
  constructor() {
  }

  GetSolicitadosByUsuario(usuarioId: number, skip: number, take: number, sort?: PagedSortType, search?: string): Promise<PagedListResponse<CampanhaPedidoResgateResponse> | Error> {
    if (search) { search = encodeURIComponent(search) }
    return Get(`${DomainConstants.apiDomain.campanhaPedidoResgate.GetSolicitadosByUsuario}?usuarioId=${usuarioId}&skip=${skip}&take=${take}${sort != undefined ? "&sort=" + sort.toString() : ""}${search != undefined ? "&search=" + search : ""}`)
  }
  GetSolicitadosByCampanha(request: PagedListRequest<CampanhaPedidoResgateResponse>): Promise<PagedListResponse<CampanhaPedidoResgateResponse> | Error> {
    return Post(DomainConstants.apiDomain.campanhaPedidoResgate.GetSolicitadosByCampanha, request)
  }
  GetSolicitadosAprovadosByCampanha(request: PagedListRequest<CampanhaPedidoResgateResponse>): Promise<PagedListResponse<CampanhaPedidoResgateResponse> | Error> {
    return Post(DomainConstants.apiDomain.campanhaPedidoResgate.GetSolicitadosAprovadosByCampanha, request)
  }

}
